import { defineMessages } from 'react-intl';

export const messages: {
	clearIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inputAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterToggleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	clearIconLabel: {
		id: 'input_clear_icon_label',
		defaultMessage: 'Clear search',
		description: 'Label text for clear search button',
	},
	inputPlaceholder: {
		id: 'input_placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder text in primary search input',
	},
	inputAriaLabel: {
		id: 'input_aria_label',
		defaultMessage: 'Search, press enter to navigate to advanced search with your text query',
		description: 'Aria label for primary search input, directs users advanced search',
	},
	filterToggleLabel: {
		id: 'search-page.common.quick-find.textfield.filterToggleLabel',
		defaultMessage: 'Filters',
		description: 'Accessible label for the button that expands or collapses Quick Find filters',
	},
});
